"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var Pill = function Pill(_ref) {
  var label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$uppercase = _ref.uppercase,
      uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline;
  var pillClasses = (0, _classnames.default)('pill', "pill--".concat(variant), {
    'pill--uppercase': uppercase,
    'pill--inline': inline
  }, className);
  return (0, _preact.h)("span", {
    className: pillClasses
  }, label);
};

var _default = Pill;
exports.default = _default;